import { GetterTree } from 'vuex'
import { RootState } from 'store'
import { ManualState } from './types'

export const getters: GetterTree<ManualState, RootState> = {
    percentUpload: (state: ManualState) => state.percent,
    loading: (state: ManualState) => state.loading,
}
